import PageLayout from "@/pages/home/components/PageLayout";
import SessionSection from "@/pages/home/components/SessionSection";

export default function SessionPage() {
  return (
    <PageLayout>
      <SessionSection />
    </PageLayout>
  );
}
